import { pageStats } from '@/mocks/movies';

const entries = [
  { href: '#today', icon: 'ri-time-line', title: '今日更新', desc: '按时间看当日新增与分集' },
  { href: '#ranking', icon: 'ri-fire-line', title: '热播榜', desc: '热度排序，追热门片单' },
  { href: '#new', icon: 'ri-movie-2-line', title: '新片上映', desc: '近期上映与新上线作品' },
  { href: '#highrated', icon: 'ri-star-smile-line', title: '高分推荐', desc: '评分较高，附推荐理由' },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20movie%20theater%20interior%20with%20warm%20amber%20spotlights%20and%20deep%20teal%20shadows%2C%20rows%20of%20empty%20seats%20in%20soft%20focus%2C%20dramatic%20light%20beams%20through%20haze%2C%20moody%20editorial%20photography%2C%20rich%20grain%20texture&width=1920&height=1080&seq=cine-hero-bg-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/85"></div>
      </div>

      <div className="relative w-full px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto flex max-w-6xl flex-col items-center text-center">
          <span className="rise-in inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs font-medium tracking-wide text-background-50/90">
            <i className="ri-play-circle-line text-sm" aria-hidden="true"></i>
            一站式影视资讯 · 无需登录即可浏览
          </span>

          <h1 className="rise-in mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            九七电影院
            <span className="mt-2 block text-lg font-medium text-accent-300 md:text-2xl">
              最新电影与热播追踪，一页看全
            </span>
          </h1>

          <p className="rise-in mt-5 max-w-3xl text-sm leading-relaxed text-background-50/85 md:text-base">
            这里聚合了九七电影院最新电影的主要内容：按时间排列的今日更新、热度排序的热播榜、刚刚开画的新片上映，
            以及区分「在映」与「即将同步」的院线同步片单。若你更在意质量，高分推荐区会用一句理由帮你判断值不值得看。
          </p>

          <div className="rise-in mt-7 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#today"
              className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-flashlight-line text-base" aria-hidden="true"></i>
              看今日更新
            </a>
            <a
              href="#ranking"
              className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              <i className="ri-bar-chart-2-line text-base" aria-hidden="true"></i>
              打开热播榜
            </a>
          </div>

          <dl className="mt-10 grid w-full grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
            {pageStats.map((stat) => (
              <div
                key={stat.id}
                className="rounded-lg border border-background-50/15 bg-background-50/10 px-4 py-3 text-center backdrop-blur-sm"
              >
                <dt className="text-xs text-background-50/70">{stat.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-bold text-accent-300">
                  {stat.value}
                  <span className="ml-0.5 text-xs font-normal text-background-50/70">{stat.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="relative w-full border-t border-background-200 bg-background-50 px-4 py-6 md:px-6 md:py-8">
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {entries.map((entry) => (
            <a
              key={entry.href}
              href={entry.href}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${entry.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="flex flex-col">
                <span className="font-heading text-base font-bold text-foreground-950">{entry.title}</span>
                <span className="mt-0.5 text-xs text-foreground-600">{entry.desc}</span>
              </span>
              <i className="ri-arrow-right-line ml-auto text-lg text-foreground-400 transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}